import React from 'react';
import { useClassName } from 'common/hooks';
import { getContentfulAssetUrlandAlt, VideoPlayer } from 'common/components';
import { inject } from 'mobx-react';
import './cover-video.less';

const CoverVideo = ({ venue }) => {
  const className = useClassName('CoverVideo');
  const coverVideo = getContentfulAssetUrlandAlt(venue?.parkScreen?.coverVideo);

  return (
    <div className={className('container')}>
      <VideoPlayer
        id={`cover-video-${venue?.slug}`}
        name={`Cover Video ${venue?.name}`}
        videoUrl={coverVideo.assetUrl}
        posterUrl={''}
        controls={false}
        autoPlay
        loop
        disablePlay
      />
    </div>
  );
};

export default inject('betaFeatures')(CoverVideo);
